import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onSetSelectedProductClassification, selectProductClassificationState, setAction } from "../redux/slices/productClassificationSlice"
import { ProductClassificationAPI } from "../apis/ProductClassificationAPI"
import { productClassification } from "../types/slices/productClassificationType"

export const useProductClassificationStore = () => {

    const dispatch = useDispatch()
    const { productClassification, productClassificationSelected, status, action } = useSelector(selectProductClassificationState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany
    
    const getProductClassification = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductClassificationAPI.getProductClassification({search:search}, idcompany)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getProductClassificationByCompany = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductClassificationAPI.getProductClassificationByCompany({search:search, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createProductClassification = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductClassificationAPI.createProductClassification({...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editProductClassification = async (idbussinesArea: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductClassificationAPI.editProductClassification(idbussinesArea, {...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteProductClassification = async (idbranchoffice: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductClassificationAPI.deleteProductClassification(idbranchoffice)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedProductClassification = (productClassification: productClassification) => {
        try {
            dispatch(onSetSelectedProductClassification(productClassification))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionClassification = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        productClassification,
        productClassificationSelected,
        status,
        action,
        //actions
        getProductClassification,
        getProductClassificationByCompany,
        createProductClassification,
        editProductClassification,
        deleteProductClassification,
        setSelectedProductClassification,
        setActionClassification,
    }
}